import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'

const ApplicationOptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'friendlyName',
})

const queryParams = {
    take: 20,
}

const getOptionLabel = (option) => option.friendlyName

const MailboxTypeFilter = () => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()

    const filter = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('MailboxType')}
                url={'/api/mailbox/mailBoxTypes'}
                queryParams={queryParams}
                method="GET"
                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={state.mailBoxTypeId ? state.mailBoxTypeId : null}
                optionComponent={ApplicationOptionComponent}
                clearIcon={
                    !isNilOrEmpty(state.application) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_PROP',
                                    payload: {
                                        key: 'mailBoxTypeId',
                                        value: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_PROP',
                        payload: {
                            key: 'mailBoxTypeId',
                            value: value,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('MailboxType')}
            color="#fff"
            collapsible
            expanded={Boolean(state.application)}
        >
            {filter}
        </Card>
    )
}

export default MailboxTypeFilter
